import { io } from "socket.io-client";
import getFullDomain from "./getFullDomain";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BASE_URL = getFullDomain(API_URL!);
export const socket = io(BASE_URL!, {
  autoConnect: false,
});
